import "../styles/evPage.css";
import type { LevelCatalog } from "@highmarch/app";
import { paintedIconHtml } from "../featureIcons";
import { SHOP_SKIN } from "../shopSkin";
import type { ListSheetHead } from "./moreSheet";

/**
 * The Events tab's page (M35 Option 1, Kevin: "an improved interface rather than More"): its header, and the line in
 * place of the Daily Orders until they open. hubView.ts builds the page (moreSheet.ts showMore) and mounts the Orders
 * (ordersSheet.ts) under the header; the rows are the features' `home: "events"` rows and the hub's Iron row.
 * UI pass 2026-10-21: the page wears the Shop's look (`s3`), opens on the live event's bright banner, and its rows are
 * compact, one line each.
 */
export const EVENTS_HEAD: ListSheetHead = {
  title: "Events", portrait: paintedIconHtml("eventEmber", 40), tint: "ember", cls: "evhub",
};

/** Before the Daily Orders open: a line saying when (the Orders section takes this place once they do). */
export function eventsPageIntro(catalog: LevelCatalog): string {
  if (catalog.orders.unlocked(catalog.highestLevelCleared)) return "";
  const from = catalog.balance.orders.unlockAfterLevel;
  return `<p class="evintro">Daily Orders open after level ${from}</p>`;
}

/** The live event's banner on the page (features/events.ts provides it while an event runs; "" otherwise). */
let bannerOf: (() => string) | null = null;
export function setEventsPageBanner(fn: (() => string) | null): void { bannerOf = fn; }

/** The Iron row's line, short enough to keep the row on one line (the hub writes a longer one). */
const IRON_NOTE_OPEN = "One long wave", IRON_NOTE_LOCKED = "Three-star a level";

/**
 * Dresses the Events page (ordersSheet.ts mountOrders calls it on the sheet hubView built): the Shop's look, the live
 * event's banner at the top (a tap opens the event, as its row does), short row lines.
 */
export function decorateEventsPage(sheet: HTMLElement): void {
  if (!sheet.classList.contains("evhub") || sheet.classList.contains("evpage")) return;
  sheet.classList.add(SHOP_SKIN, "evpage");
  const html = bannerOf?.() ?? "";
  if (html) {
    const head = sheet.querySelector(".sheethead");
    head?.insertAdjacentHTML("afterend", html);
    const b = sheet.querySelector<HTMLButtonElement>(".evbnr.evpagebnr");
    if (b) b.onclick = () => sheet.querySelector<HTMLButtonElement>(".mlist .mrow.events")?.click();
  }
  const iron = sheet.querySelector<HTMLElement>(".mrow.iron small");
  if (iron) iron.textContent = /^Three-star/.test(iron.textContent ?? "") ? IRON_NOTE_LOCKED : IRON_NOTE_OPEN;
}
